import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=f594ff6a&scoped=true"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"
import style0 from "./QuestionsAndAnswers.vue?vue&type=style&index=0&id=f594ff6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f594ff6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f594ff6a')) {
      api.createRecord('f594ff6a', component.options)
    } else {
      api.reload('f594ff6a', component.options)
    }
    module.hot.accept("./QuestionsAndAnswers.vue?vue&type=template&id=f594ff6a&scoped=true", function () {
      api.rerender('f594ff6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuestionsAndAnswers.vue"
export default component.exports